var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23",
    "data-name": "Layer 23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.44 17a1.49 1.49 0 0 0 2.07-.45l7.11-11.05h16.69l-11.71 18.87a1.51 1.51 0 0 0 1.28 2.29h8.89l-6.31 6.34c-1.4 1.36.77 3.52 2.12 2.12l8.87-8.88a1.51 1.51 0 0 0 -1.06-2.56h-9.82l11.7-18.89a1.5 1.5 0 0 0 -1.27-2.29h-20.2a1.49 1.49 0 0 0 -1.26.69l-7.54 11.81a1.49 1.49 0 0 0 .44 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.06 50.94-40-40a1.5 1.5 0 0 0 -2.12 2.12l8.06 8.09-6.3 9.85a1.51 1.51 0 0 0 1.3 2.34h13.32l-12.13 26a1.5 1.5 0 0 0 2.42 1.69l20.67-20.63 12.66 12.66a1.5 1.5 0 0 0 2.12 0 1.49 1.49 0 0 0 0-2.12zm-36.36-20.6 4.5-7 7 7zm4.8 22.6 9.31-20 5.35 5.34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashEnergy);
export default __webpack_public_path__ + "static/media/flashEnergy.62bb167990614e06351545fee6039d61.svg";
export { ForwardRef as ReactComponent };